<template>
  <div class="content_box">
    <div v-if="!consInfo.consId">
      <van-field v-model="consNo" center clearable placeholder="请输入要缴费的用户电号" />
      <div style="padding: 0.5rem 0.24rem">
        <van-button @click="queryFeeCons" type="primary" block>下一步</van-button>
      </div>
    </div>
    <div v-if="consInfo.consId">
      <!-- <div class="info_box"> -->
      <!-- <div class="charge_info">用户信息</div> -->
      <van-field disabled :value="consInfo.consNo" type="text" label="户号" />
      <van-field disabled :value="consInfo.consName" type="text" label="户名" />
      <van-field disabled :value="consInfo.balance" type="text" label="当前余额" />
      <van-field disabled :value="consInfo.elecAddr" type="text" label="地址" />
      <!-- </div> -->
      <div class="charge_box">
        <div class="charge_info">充值金额</div>
        <van-field v-model="value1" left-icon="gold-coin-o" placeholder="请输入充值金额" />
        <div class="price_box">
          <div
            @click="changePrice(item)"
            class="recharge_price"
            :style="
              item == value1 ? 'background-color: #50c7a1;color: #FFFFFF' : ''
            "
            v-for="item in recommandPriceList"
          >{{ item }}元</div>
        </div>
        <div class="charge_info" style="margin-top: 0.3rem">
            <div class="charge_title">请选择支付方式</div>
          </div>
          <div class="payment_box">
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/wx.png" alt class="icon" />
                <span>微信支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_WX'" @click="checkChange('UNIONPAY_WX')" icon-size="18px"></van-checkbox>
            </div>
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/zfb.png" alt class="icon" />
                <span>支付宝支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_ALI'" @click="checkChange('UNIONPAY_ALI')" icon-size="18px"></van-checkbox>
            </div>
            <div class="payment_item">
              <div style="display: flex; align-items: center">
                <img src="@/assets/ysf.jpg" alt class="icon" />
                <span>云闪付支付</span>
              </div>
              <van-checkbox :value="checkedType=='UNIONPAY_UAC'" @click="checkChange('UNIONPAY_UAC')" icon-size="18px"></van-checkbox>
            </div> 
          </div>
      </div>
      
      <div style="padding: 0.5rem 0.24rem">
        <div class="recharge_btn" @click="unionPayCreateOrder">立即充值</div>
        <div @click="backBefore" style="width:100%;color:#00a578;font-size: 14px;height: 0.65rem;line-height: 0.65rem;cursor: pointer;">返回上一步</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup, Button, Notify } from "vant";
import { Field } from "vant";
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Notify);
import { queryFeeCons, queryOpenid, createOrder,unionPayCreateOrder2 } from "@/api/user.js";
export default {
  data() {
    return {
      consNo: "",
      openid: "",
      consInfo: {},
      orderAmount: 100,
      recommandPriceList: [100, 200, 300],
      value1: "",
      checkedType: "UNIONPAY_WX",
      canclick: true,
    };
  },
  created() {
    if (this.$route.query.code) {
      queryOpenid(this.$route.query.code).then(res => {
        if (res.data.status == 200) {
          this.openid = res.data.object;
        }
      });
    }
  },
  methods: {
    backBefore() {
      this.consInfo = {};
    },
    changePrice(price) {
      this.value1 = price;
    },
    queryFeeCons() {
      if (this.consNo) {
        queryFeeCons(this.consNo).then(res => {
          if (res.data.status == 200) {
            this.consInfo = res.data.object;
            if (this.consInfo.balance < 0) {
              this.value1 = Math.abs(this.consInfo.balance);
            }
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      } else {
        Notify({ type: "danger", message: "请先输入要缴费的户号！" });
      }
    },
    toCharge() {
      if (!this.consInfo || !this.consInfo.consId) {
        Notify({ type: "danger", message: "请先输入要缴费的户号！" });
        return;
      }
      if (this.consInfo.balance < 0) {
        if (this.value1 < Math.abs(this.consInfo.balance)) {
          Notify({ type: "danger", message: "充值金额需大于欠费金额！" });
          return;
        }
      }
      createOrder({
        consId: this.consInfo.consId,
        openid: this.openid,
        orderAmount: this.value1
      }).then(res => {
        if (res.data.status == 200) {
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
            }
          } else {
            this.onBridgeReady(res.data.object);
          }
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    checkChange(checkedType) {
      this.checkedType = checkedType;
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, function(res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      });
    },
    unionPayCreateOrder() {
      if (!this.canclick) {
        Notify({ type: "danger", message: "请勿重复点击" });
        return;
      }

      if (this.consInfo.balance < 0) {
        if (this.value1 < Math.abs(this.consInfo.balance)) {
          Notify({ type: "danger", message: "充值金额需大于欠费金额！" });
          return;
        }
      }

      this.canclick = false;

      unionPayCreateOrder2({
        consId: this.consInfo.consId,
        orderAmount: this.value1,
        payMethod: this.checkedType
      }).then(res => {
        this.canclick = true;
        if (res.data.status == 200) {
          window.location.href = res.data.object;  
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
  }
};
</script>
<style scoped>
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
.price_box {
  display: flex;
  margin-top: 0.4rem;
  justify-content: space-between;
}
.recharge_price {
  width: 1.6rem;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.6rem;
  margin: 0.02rem 0.1rem;
  background-color: #efefef;
}

.charge_info {
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  font-size: 0.28rem;
  line-height: 0.28rem;
  padding: 0.3rem 0.2rem 0rem 0.2rem;
}
.charge_info::before {
  content: "";
  display: inline-block;
  margin-right: 0.08rem;
  width: 0.06rem;
  height: 0.28rem;
  background-color: #50c7a1;
}
.charge_title {
  font-size: 0.26rem;
  margin-left: 0.05rem;
}
.line {
  width: 0.05rem;
  height: 0.3rem;
  background: #378a37;
}
.charge_box {
  margin-bottom: 0.2rem;
}
.van-button--block {
  height: 0.65rem;
  background-color: #00a578;
  border-color: #008c65;
}
.input_box {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  border: 1px solid #cccccc;
}
.querybtn {
  color: #0db197;
}
.note_title {
  top: -13px;
  left: 110px;
  width: 118px;
  font-size: 20px;
  color: #33bf93;
  font-weight: bold;
  position: absolute;
  background: #fff;
}

.note_box {
  padding: 20px 20px 0 20px;
  height: 210px;
  margin: 0 20px;
  margin-top: 50px;
  font-size: 14px;
  position: relative;
  border: 1px solid #33bf93;
}

.payment_item {
  display: flex;
  font-size: 0.26rem;
  margin-top: 0.25rem;
  align-items: center;
  justify-content: space-between;
}
.icon {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.2rem;
}
.payment_box {
   margin: 0 0.2rem;
}
p{
  text-align: left;
}
</style>